__turbopack_context__.v({
  "button": "_1PJRMG_button",
  "button__disabled": "_1PJRMG_button__disabled",
  "button__loading": "_1PJRMG_button__loading",
  "container": "_1PJRMG_container",
  "shimmer": "_1PJRMG_shimmer",
  "text-bar-sweep": "_1PJRMG_text-bar-sweep",
});
